module.exports = __webpack_public_path__ + "img/e38dbd7.png";